import { f7 } from "framework7-vue";
import { createStore, createLogger } from 'vuex';
import { i18n } from "@/js/i18n.js";
import modules from './modules'; // 引入modules

const store = createStore({
  modules,
  // 放到這裡
  state() {
    return {
      // 語系
      locale: null,
      // 員工
      staff: {
        ordersPermission: false,
        muPermission: false,
        code: '',
        name: '',
        partitionID: 0,
        id: 0
      }
    };
  },
  getters: {
    // 已登入
    staffInfo(state, getters) {
      return reactive({
        ordersPermission: computed(() => parseInt(state.staff.ordersPermission)),
        muPermission: computed(() => state.staff.muPermission),
        code: computed(() => state.staff.code),
        name: computed(() => state.staff.name),
        id: computed(() => state.staff.id),
        partitionID: computed(() => state.staff.partitionID)
      });
    }
  },
  actions: {
    // 初始
    init({
      commit
    }) {
      var locale = localStorage.getItem("MukiLang");
      // 語系
      if (locale) {
        commit('updateLocale', locale);
      } else {
        commit('updateLocale', mukiConst.locale['TW']);
      }
    }
  },
  mutations: {
    // 更新語系
    updateLocale(state, langStr) {
      var locale = null;
      switch (langStr) {
        case mukiConst.locale['TW']:
          locale = mukiConst.locale['TW'];
          break;
        case mukiConst.locale['EN']:
          locale = mukiConst.locale['EN'];
          break;
        case mukiConst.locale['TH']:
          locale = mukiConst.locale['TH'];
          break;
        case mukiConst.locale['KR']:
          locale = mukiConst.locale['KR'];
          break;
        case mukiConst.locale['VN']:
          locale = mukiConst.locale['VN'];
          break;
        case mukiConst.locale['BD']:
          locale = mukiConst.locale['BD'];
          break;
        case mukiConst.locale['ID']:
          locale = mukiConst.locale['ID'];
          break;
        case mukiConst.locale['TR']:
          locale = mukiConst.locale['TR'];
          break;
        case mukiConst.locale['UZ']:
          locale = mukiConst.locale['UZ'];
          break;
        case mukiConst.locale['RU']:
          locale = mukiConst.locale['RU'];
          break;
        case mukiConst.locale['ES']:
          locale = mukiConst.locale['ES'];
          break;
        case mukiConst.locale['AB']:
          locale = mukiConst.locale['AB'];
          break;
        default:
          locale = mukiConst.locale['EN'];
          break;
      }
      if (typeof i18n !== "undefined") {
        if (i18n.global.locale.value) {
          i18n.global.locale.value = locale;
        }
      }
      if (locale) {
        state.locale = locale;
        localStorage.setItem("MukiLang", locale);
      }
    },
    // 更新會員資料
    updateStaff(state, staff) {
      if (staff) {
        state.staff = staff;
      }
    }
  },
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : []
});
export default store;